var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cliam-\\u6CE8\\u518C",
    transform: "translate(-993.000000, -137.000000)",
    fill: "#141416"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(993.000000, 137.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    transform: "translate(5.656854, 5.656854) rotate(-315.000000) translate(-5.656854, -5.656854) ",
    x: -1.34314575,
    y: 4.65685425,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-13",
    transform: "translate(5.656854, 5.656854) scale(-1, 1) rotate(-315.000000) translate(-5.656854, -5.656854) ",
    x: -1.34314575,
    y: 4.65685425,
    width: 14,
    height: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ccd6dbdb81b9496c9ed84aa55af80d0c.svg";
export { ForwardRef as ReactComponent };